import { render, staticRenderFns } from "./EditUADialog.vue?vue&type=template&id=070807e2&scoped=true"
import script from "./EditUADialog.vue?vue&type=script&lang=ts"
export * from "./EditUADialog.vue?vue&type=script&lang=ts"
import style0 from "./EditUADialog.vue?vue&type=style&index=0&id=070807e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070807e2",
  null
  
)

export default component.exports